<fieldset>
 <legend>
  AttributionFromFNSimple
 </legend>

<!---->

<fieldset>
 <legend>
  avisInitial
 </legend>
 <app-avis-initial-type  [uid]="getUid()" [parentForm]="parentForm" [avisInitial]="attributionFromFNSimple.avisInitial"></app-avis-initial-type>
</fieldset>

<!---->

<app-form-input 
[parentForm]="parentForm" 
[value]="attributionFromFNSimple.pasAvisInitial" 
 
[label]="'pasAvisInitial'"
[type]="'text'"
[rule]="''"
[name]="getUid()+'_SepAtt_pasAvisInitial'">
</app-form-input>
</fieldset>